// extracted by mini-css-extract-plugin
export var black = "_4s-1";
export var brand = "_4s-4";
export var dark = "_4s-7";
export var error = "_4s-5";
export var gray = "_4s-3";
export var light = "_4s-0";
export var modern = "_4s-8";
export var success = "_4s-2";
export var warning = "_4s-6";